'use strict';

import angular from 'angular';

import modalDirective from 'brg/rest/buttons/modal';
import resolveUsers from 'utils/resolve/users';

import addTemplate from './add.html';

const MODULE_NAME = 'daupler.entities.admin.incidentLeader';

var app = angular.module(MODULE_NAME, [
	'ui.mask',
	'brg.components.inputs',
]);

app.directive('addEntityIncidentLeader', modalDirective({
	template: addTemplate,
	resolve: {
		users: resolveUsers,
	},
	controller: addController,
}));

export default MODULE_NAME;


function addController($scope) {
	'ngInject';

	$scope.updatePhoneNumber = function(item, modal, label) {
		if ($scope.$context.userPhoneNumber) {
			$scope.leader.phone_number = item.phone_number;
		}
	}

	$scope.updateLeader = function(response) {
		var data = response.data;
		angular.merge($scope.$context.currentLeader, {
			phone_number: data.phone_number,
			user: data.user,
			created_time: new Date(),
		});
	}
}
